import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title, subtitle, action }) => {
  const nav = useNavigate();
  return (
    <div className="pt-6 pb-4">
      <div className="flex items-center justify-between gap-2 mb-2">
        <button
          onClick={() => nav(-1)}
          className="w-10 h-10 brutal-border rounded-full bg-white flex items-center justify-center brutal-shadow-sm"
          data-testid="page-back-btn"
        >
          <ArrowLeft className="w-4 h-4" />
        </button>
        {action}
      </div>
      <h1 className="font-heading font-black text-3xl tracking-tight leading-none">{title}</h1>
      {subtitle && <p className="text-sm text-[#555555] mt-1">{subtitle}</p>}
    </div>
  );
};

export default PageHeader;
